/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var timeout = require('../../utils/promise/timeout');
var tracker = require('../../utils/timeTracker');

var mySegmentsService = require('../../services/mySegments');
var mySegmentsRequest = require('../../services/mySegments/get');

var mySegmentsFetcher = function mySegmentsFetcher(settings) {
  var startingUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var metricCollectors = arguments[2];

  var mySegmentsPromise = mySegmentsService(mySegmentsRequest(settings));

  tracker.start(tracker.TaskNames.MY_SEGMENTS_FETCH, startingUp ? metricCollectors : false, mySegmentsPromise);

  // Decorate with the timeout functionality if required
  if (startingUp) {
    mySegmentsPromise = timeout(settings.startup.requestTimeoutBeforeReady, mySegmentsPromise);
  }

  // Extract segment names
  return mySegmentsPromise.then(function (resp) {
    return resp.json();
  }).then(function (json) {
    return json.mySegments.map(function (segment) {
      return segment.name;
    });
  });
};

module.exports = mySegmentsFetcher;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/producer/fetcher/MySegments.js
// module id = 694
// module chunks = 10